import Image from 'next/image';
import { useState } from 'react';
import cn from 'classnames';
import { useKeenSlider } from 'keen-slider/react';
import 'keen-slider/keen-slider.min.css';
import { MobileData } from './mobile-data';

import TooltipsSvg from './tooltips';
import DroneSvg from './drone';
import PortSvg from './port';
import GradientSvg from './gradient';

const SmartPortIllustration = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [loaded, setLoaded] = useState(false);
  const [slideCount, setSlideCount] = useState(0);

  const [sliderRef, instanceRef] = useKeenSlider({
    slides: {
      perView: 'auto',
      spacing: 10,
      origin: 'center'
    },
    initial: 0,
    created(slider) {
      setLoaded(true);
      setSlideCount(slider.slides.length);
    },
    slideChanged(slider) {
      setCurrentSlide(slider.track.details.rel);
    }
  });

  return (
    <>
      <div className="md:block hidden relative aspect-[1258/1136]">
        <TooltipsSvg className="absolute w-full h-full z-20" />
        <PortSvg className="absolute w-full h-full z-10" />
        <DroneSvg className="absolute w-full h-full z-10" />
        <GradientSvg className="absolute w-full h-full" />
      </div>

      <div className="md:hidden">
        <div ref={sliderRef} className="keen-slider">
          {MobileData &&
            MobileData.map(item => (
              <div
                className="keen-slider__slide relative h-[416px] min-w-[316px] py-9 flex flex-col"
                key={item.title}
              >
                {item.title && (
                  <p className="relative z-10 text-center text-xl leading-[26px] px-10">
                    {item.title}
                  </p>
                )}
                {item.subtitle && (
                  <p
                    className="mt-auto relative z-10 text-center text-base leading-[19px] text-scale-lightmauve px-7"
                    dangerouslySetInnerHTML={{ __html: item.subtitle }}
                  />
                )}
                <Image
                  src={item.img}
                  alt={item.title}
                  fill
                  quality={100}
                  className="absolute object-contain z-0"
                />
              </div>
            ))}
        </div>
        {loaded && instanceRef.current && slideCount > 1 && (
          <div className="w-full flex items-center justify-center mt-5">
            <div className="flex justify-center space-x-2 transform bottom-4 max-w-max">
              {[...Array(instanceRef.current.track.details.slides.length).keys()].map(idx => (
                <span
                  key={idx}
                  onClick={() => {
                    instanceRef.current.moveToIdx(idx);
                  }}
                  className={cn(
                    'h-3 w-3 rounded-full cursor-pointer',
                    currentSlide === idx ? 'bg-scale-mauve' : 'bg-emperor'
                  )}
                />
              ))}
            </div>
          </div>
        )}
      </div>
    </>
  );
};
export default SmartPortIllustration;
